import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Menuudbyder',
      options: {
        [null]: 'Vælg menuudbyder',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Anden FoodAmigos-restaurant',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'Lieferando-URL',
        placeholder: 'Restaurantens URL på Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'Wolt-URL',
        placeholder: 'Restaurantens URL på Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Link til Deliveroo-menu',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Åbn din restaurant på Deliveroo, og kopiér linket fra adresselinjen.',
        error:
          'Indtast linket til en menuside for en Deliveroo-restaurant. Det ser ud som https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'Uber Eats-URL',
        placeholder: 'Restaurantens URL på Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'GloriaFood-link',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Hvis du bruger GloriaFoods bestillingsside:',
            description: 'Indtast din bestillings-URL på foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Hvis GloriaFood er indlejret på din egen hjemmeside:',
            description: "Indtast URL'en på den side på dit websted, hvor bestillingswidgetten vises.",
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Indtast et gyldigt link, der starter med https://.',
        back_office_error:
          'Det er et link til GloriaFoods back office og ikke til den side, dine kunder bestiller fra. Åbn din restaurants bestillingsside, og indsæt det link i stedet.',
        wrong_platform_error:
          "Dette ligner ikke et GloriaFood-link. Hvis du bruger GloriaFoods hostede side, skal du indtaste din bestillings-URL på foodbooking.com. Hvis GloriaFood er indlejret på din egen hjemmeside, skal du indtaste URL'en på den side, hvor din bestillingswidget vises.",
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'Thuisbezorgd-URL',
        placeholder: 'Restaurantens URL på Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'Takeaway.com-URL',
        placeholder: 'Restaurantens URL på Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'Pyszne.pl-URL',
        placeholder: 'Restaurantens URL på Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'Bistro.sk-URL',
        placeholder: 'Restaurantens URL på Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'Just Eat-URL',
        placeholder: 'Restaurantens URL på Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Link til DoorDash-butik',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Åbn din restaurant på doordash.com, og kopiér linket fra adresselinjen.',
        error: 'Indtast linket til en DoorDash-butiksside. Det starter med https://www.doordash.com/store/.',
        store_number_error:
          'Det link indeholder kun butiksnummeret. Åbn restauranten på doordash.com, og kopiér linket med navnet, f.eks. https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant at kopiere menu fra',
        placeholder: 'Vælg restaurant at kopiere menu fra',
      },
    },
  },
};
